module.exports = __webpack_public_path__ + "img/image21.e83129a7.png";